import React from 'react';
import s from './LeadLiveIcon.scss';

const LeadLiveIcon = ({ text = 'LIVE' }) => (
  <span className={s.liveNowIcon}>{text}</span>
);

export default LeadLiveIcon;
